import { PasswordNormalizer, PasswordSanitizer } from "../Utils/PasswordSanitizer";


export class CustomerAccessMessageBuilder
{
//     public static SmsV1(password: string, deviceId: string, serverId: string): string
//     {
//         let pass = PasswordNormalizer.Normalize(password);

//         let sms = `🛟 Instrukcja obsługi: {tutorial-page}

// 💻 Wejdź na stronę {watcher-login-page} i wpisz "{password}",  
// lub kliknij ten link: {watch-page}

// 📱 Opcjonalnie w telefonie ustaw hotspot z nazwą "{deviceId}" i hasłem "{deviceId}password". 
// `;

        // sms = CustomerAccessMessageBuilder.ReplaceParams(sms, serverId, deviceId, pass);

//         return sms;
//     }

    public static Sms(password: string, deviceId: string, serverId: string): string
    {
        const tutorialPage = process.env.TUTORIAL_PAGE || "https://tutorial.specteam.pl";
        const watcherPage = process.env.WATCHER_PAGE || "https://watcher.specteam.pl";
        const sanitizedPassword = PasswordSanitizer.Sanitize(password);
        const normalizedPassword = PasswordNormalizer.Normalize(sanitizedPassword);

        return `🎓 Instrukcja obsługi: 
${tutorialPage}

📱 Szybki podgląd: 
${watcherPage}#watch/${serverId}/${sanitizedPassword}

💻 Podgląd na komputerze: 
${watcherPage}#login/${serverId} 
hasło: "${normalizedPassword}"

🛜 Opcjonalnie w telefonie ustaw hotspot z nazwą "${deviceId}" i hasłem "${deviceId}password"`;
    }

    // private static ReplaceParams(txt: string, serverId: string, deviceId: string, passwordWithSpaces: string)
    // {
    //     const sanitizedPassword = PasswordSanitizer.Sanitize(passwordWithSpaces);
    //     const watchPage = process.env.WATCHER_WATCH_PAGE
    //         ?.replace("{server}", serverId)
    //         ?.replace("{password}", sanitizedPassword);
    //     const loginPage = process.env.WATCHER_LOGIN_PAGE
    //         ?.replace("{server}", serverId);

    //     txt = txt
    //         .replace("{watcher-page}", process.env.WATCHER_PAGE || "🥔")
    //         .replace("{watcher-login-page}", loginPage || "🥔")
    //         .replace("{watch-page}", watchPage || "🥔")
    //         .replace("{password}", passwordWithSpaces || "🥔")
    //         .replace(/{deviceId}/g, deviceId || "🥔")
    //         .replace("{tutorial-page}", process.env.TUTORIAL_PAGE || "🥔")

    //     return txt;
    // }
}
